export class RinknetAttachment {
    constructor(json?: any) {
        this.id = json && json.service_user && json.service_user.id || null;
        this.userID = json && json.user && json.user.id || null;
        this.firstName = json && json.user && json.user.first_name || null;
        this.lastName = json && json.user && json.user.last_name || null;
        this.email = json && json.user && json.user.email || null;
        this.databaseName = json && json.service_user && json.service_user.database || null;
        this.databaseDisplayName = json && json.service_user && json.service_user.display_database || null;
        this.serviceID = json && json.service && json.service.id || null;
        this.serviceName = json && json.service && json.service.name || null;
        this.serviceUsername = json && json.service_user && json.service_user.username || null;
    }

    id: number;
    userID: number;
    firstName: string;
    lastName: string;
    email: string;
    databaseName: string;
    databaseDisplayName: string;
    serviceID: number;
    serviceName: string;
    serviceUsername: string;
}